import type { IDateCellProps } from "./types";

import { useConvertDate } from "@utils";

export function DateCell(props: IDateCellProps) {
  const { date, variant } = props;
  const { humanizeDate, humanizeFullDate, humanizeFullTime, humanizeTime } =
    useConvertDate();

  if (variant === "date") {
    return <>{humanizeDate(date)}</>;
  }
  if (variant === "full_date") {
    return <>{humanizeFullDate(date)}</>;
  }
  if (variant === "full_time") {
    return <>{humanizeFullTime(date)}</>;
  }
  if (variant === "time") {
    return <>{humanizeTime(date)}</>;
  }

  return <div>{"- - -"}</div>;
}
